import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardImgOverlay, CardHeader, CardTitle, CardBody, Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { slugify } from '../../../../../util/text';

import { getContentBlockItemsByName, getContentBlockItemByName, getContentBlockMixedItem } from '../../../CmsActions';

import Breadcrumbs from '../../../../App/components/view/Breadcrumbs';
import HtmlComponent from '../../../../../components/Text/HtmlComponent';
import FileLoader from '../../../../../components/Content/FileLoader';
import CmsPanel from '../../content/CmsPanel';
import CmsBlockItem from '../../content/CmsBlockItem';
import PreFooter from '../../../../App/components/PreFooter';

const PageMenu = ({ page }) => {
    const image = getContentBlockItemByName(page.blocks, 'image');
    const title = getContentBlockItemByName(page.blocks, 'title');
    const contents = getContentBlockItemsByName(page.blocks, 'content');

    const titles = contents.map(content => getContentBlockMixedItem(content, 'title')).filter(title => title);

    return (
        <Fragment>
            <Container>
                <Card>
                    {image && <FileLoader filename={image.path} loadonmount className="card-img" style={{ minHeight: '200px' }} />}
                    <CardImgOverlay>
                        <Breadcrumbs crumb={page && page.title} />
                    </CardImgOverlay>
                </Card>
                <div className={classnames(image && 'override-block-lg')}>
                    <Row>
                        {
                            titles && titles.length > 0 && (
                                <Col xs="12" md="3">
                                    <div className="p-3 pl-4 bg-light">
                                        {contents && contents.length > 0 && (
                                            <ol>
                                                {titles.map((title, index) => <li key={index}><a href={`#${slugify(title.text)}`}>{title.text}</a></li>)}
                                            </ol>
                                        )}
                                    </div>
                                </Col>
                            )
                        }
                        <Col>
                            {title && <h1 className="text-dark">{title.text}</h1>}
                            {contents.map((content, index) => (
                                <div key={index} id={getContentBlockMixedItem(content, 'title') && slugify(getContentBlockMixedItem(content, 'title').text)} className="mb-5">
                                    {getContentBlockMixedItem(content, 'title') && <h2>{getContentBlockMixedItem(content, 'title').text}</h2>}
                                    {getContentBlockMixedItem(content, 'text') && <CmsBlockItem item={getContentBlockMixedItem(content, 'text')} type="html" />}
                                    {getContentBlockMixedItem(content, 'image') && <div className="text-center"><CmsBlockItem item={getContentBlockMixedItem(content, 'image')} type="image" /></div>}
                                </div>
                            ))}
                        </Col>
                    </Row>
                </div>
            </Container>

            <CmsPanel slug="product-highlight" />

            <PreFooter />
        </Fragment>
    );
};

PageMenu.propTypes = {
    page: PropTypes.object.isRequired,
};

export default PageMenu;

export const PageMenuModel = {
    type: 'page',
    name: 'pageMenu',
    blocks: [
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'content',
            type: 'mixed',
            blocks: [
                {
                    name: 'title',
                    type: 'text',
                    max: 1,
                },
                {
                    name: 'text', // name or id; MUST be unique
                    type: 'html', // || text || link || image || mixed (with children)
                    max: 1, // max same items allowed
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
            ],
        },
    ],
};
